'use client'

import { Cell, Text, Icon } from '@vinted/web-ui'
import { CancelCircleFilled24 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/shared/i18n'

const GeneralError = () => {
  const translate = useTranslate('business.registration.errors.general')

  return (
    <Cell
      theme="warning"
      prefix={
        <Icon
          name={CancelCircleFilled24}
          color={Icon.Color.GreyscaleLevel7}
          aria={{ 'aria-hidden': 'true' }}
        />
      }
      title={<Text as="h2" text={translate('title')} theme="inverse" type={Text.Type.Title} />}
      body={<Text as="span" text={translate('body')} theme="inverse" type={Text.Type.Body} />}
    />
  )
}

export default GeneralError
